import List from '@mui/material/List';
import type { Notification } from '@witmetrics/utils';
import { useDispatch } from '@witmetrics/data-store';
import { API } from '@/api';
import { useAppState } from '@/providers/AppStateProvider';
import NotificationsListItem from './NotificationsListItem';

export { NotificationsListItem };

export type NotificationsListProps = {
  isFetchingData?: boolean;
  className?: string;
  itemClassName?: string;
  notifications: Notification[];
  onOpen?: (notification: Notification) => void;
  onDelete?: (notificationId: number) => void;
};

export default function NotificationsList({
  isFetchingData,
  className,
  itemClassName,
  notifications,
  onOpen,
  onDelete,
}: NotificationsListProps) {
  // TODO: isFetchingData
  const dispatch = useDispatch();
  const { onApiError } = useAppState();

  const handleDelete = (notificationId: number) => {
    try {
      // No real need to wait for the API response
      API.Notifications.removeNotification(notificationId);
      dispatch.deleteNotification({ notificationId });
      if (onDelete) onDelete(notificationId);
    } catch (err) {
      onApiError(err, 'Error deleting notification');
    }
  };

  return (
    <List className={className}>
      {notifications.map((n) => (
        <NotificationsListItem
          key={n.id}
          className={itemClassName}
          notification={n}
          onOpen={onOpen}
          onDelete={handleDelete}
        />
      ))}
    </List>
  );
}
